<template>
	<div class="category">
		<label class="custom-control custom-checkbox category-name" :class="{highlighted: filteredIds[0] === categoryId}" v-if="cache.categories[categoryId]">
			<input type="checkbox" class="custom-control-input" @click="$emit('selected', {id: categoryId, value: $event.target.checked})" :checked="selection[categoryId]">
			<!-- <input type="checkbox" class="custom-control-input" @changed="$emit('selected', {id: categoryId, value: $event.target.checked})"> -->
			<span class="custom-control-indicator"></span>
			<span class="custom-control-description">
				{{ cache.categories[categoryId].name }}
			</span>
		</label>
		<button type="button" class="category-button pull-right" v-if="(childrenToShow.length || !this.expanded) && cache.categories[categoryId]" @click.prevent="expanded = !expanded">
			<i :class="'fa-fw fa fa-chevron-' + (expanded ? 'down' : 'right') + ' text-muted'"></i>
		</button>
			<!-- <button type="button" class="category-button" v-else><i class="fa fa-circle text-muted"></i></button> -->
		<template v-for="category in childrenToShow">
			<category-recursive
				v-show="expanded"
				:category-id="category.id"
				:filtered-ids="filteredIds"
				:only-filtered="onlyFiltered"
				:selection="selection"
				@selected="$emit('selected', $event)"></category-recursive>
		</template>
	</div>
</template>

<script>
var cache = require('./category-cache');
var selfComponent = module.exports = {
	name: 'category-recursive',
	props: ['categoryId', 'filteredIds', 'onlyFiltered', 'selection'],
	data: () => ({
		cache: cache.data,
		expanded: true
	}),
	computed: {
		childCategories () {
			let children = [];
			for (let childCategoryId in this.cache.categories) {
				let childCategory = this.cache.categories[childCategoryId];
				if (childCategory.parent === this.categoryId || (!childCategory.parent && !this.categoryId)) {
					children.push(childCategory);
				}
			}
			return children;
		},
		filteredChildren () {
			if (!Array.isArray(this.filteredIds)) return [];
			let childrenSet = {};
			for (var i = 0; i < this.filteredIds.length; i++) {
				let id = this.filteredIds[i];
				let category = this.cache.categories[id];
				let iterations = 20;

				while (iterations > 0 && category && !(category.parent === this.categoryId || (!category.parent && !this.categoryId))) {
					iterations--;
					category = this.cache.categories[category.parent];
				}
				if (iterations > 0 && category) {
					childrenSet[category.id] = true;
				}
			}

			let children = [];
			for (var id in childrenSet) {
				children.push(this.cache.categories[id]);
			}
			return children;
		},
		childrenToShow () {
			if (!this.onlyFiltered) {
				return this.childCategories;
			} else {
				return this.filteredChildren;
			}
		}
	},
	created () {
		cache.prepare(this);
	},
	components: {
		'category-recursive': selfComponent
	}
};
</script>

<style>


.category > .category > .category {
	padding-left: 20px;
}
.category > .category > .category > .category-name {
	margin-left: 20px;
}
button + .category-name {
	margin-left: 0 !important;
}

label.category-name.category-name {
	position: relative;
	top: initial;
	display: inline-block;
	margin-right: 0;
}

.category-name::before {
	content: '';
	z-index: -1;
	position: absolute;
	left: -200px;
	right: -600px;
	height: 1.8em;
	top: -0.2em;
}

.category-name.highlighted::before {
	background-color: rgb(235, 233, 233);
}

.category-name:hover {
	background-color: rgb(198, 198, 198);
}

.category-button {
	left: -20px;
	background: transparent;
	border: none;
	padding: 0;
	margin-right: 2px;
}

</style>



// WEBPACK FOOTER //
// recursive.vue?11c2fbee